"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getFulfilledValue = void 0;
/**
 * Check if a promise is fulfilled and return its value.
 *
 * @param result
 * @param defaultValue
 */ var getFulfilledValue = function(result, defaultValue) {
    return result.status === 'fulfilled' ? result.value : defaultValue !== null && defaultValue !== void 0 ? defaultValue : null;
};
exports.getFulfilledValue = getFulfilledValue; //# sourceMappingURL=getFulfiledValue.js.map
